function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  stroke: "#000",
  strokeWidth: 3.36,
  x: -0.865,
  y: -0.72,
  width: 134.4,
  height: 284.6,
  rx: 12.13,
  transform: "translate(3 3)",
  fill: "none",
  fillRule: "evenodd"
});

function SvgPhoneFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139 290"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzkgMjkwIj48ZGVmcy8+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0wIDBoNzguMDA5djE2Ljc3OUgweiIvPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDMpIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIzLjM2IiB4PSItLjg2NSIgeT0iLS43MiIgd2lkdGg9IjEzNC40IiBoZWlnaHQ9IjI4NC42IiByeD0iMTIuMTMiLz48L2c+PC9zdmc+";
export { SvgPhoneFrame as ReactComponent };